import React, {PureComponent} from 'react';

import LandingFreelance from './LandingFreelanceUniverse.jsx';

import header from './images/header-finance.png?size=600';

const metaDescription = "Profitez d'un accompagnement personnalisé et accédez à des missions pour consultant expert finance : contrôle de gestion, trésorerie, consolidation et comptabilité.";
const metaTitle = "Twineeds | Missions pour experts en finance";

export default class LandingFreelanceFinance extends PureComponent {
  render() {
    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="de la finance"
        title="Mandats pour professionnels de la Finance"
        universeCode="finance"
      />
    )
  }
}
